// Export del Excel de Inventario Disponible. La construcción del array de filas
// (buildInventarioExcelAoa) es pura/testeable; exportInventarioExcel añade la
// descarga con XLSX. Para AVP (isAvpOnly) se omite la columna Talla (la vista
// viene agrupada por artículo+color+estilo). Empresa y Almacén solo para Empresa.All.
import * as XLSX from 'xlsx'
import type { TFunction } from 'i18next'
import type { InventarioRow } from '@/types'

export interface InventarioExcelOpts {
  isEmpresaAll: boolean
  isAvpOnly: boolean
  t: TFunction
  fmtArt: (s: string) => string
}

export function buildInventarioExcelAoa(
  rows: InventarioRow[],
  { isEmpresaAll, isAvpOnly, t, fmtArt }: InventarioExcelOpts,
): (string | number)[][] {
  const showTalla = !isAvpOnly
  const header: (string | number)[] = [
    ...(isEmpresaAll ? [t('inventory.excel.company')] : []),
    t('inventory.excel.article'), t('inventory.excel.description'),
    t('inventory.excel.family'),
    ...(isEmpresaAll ? [t('inventory.excel.warehouse')] : []),
    t('inventory.excel.color'),
    ...(showTalla ? [t('inventory.excel.size')] : []),
    t('inventory.excel.style'),
    t('inventory.col.physicalStock'), t('inventory.col.physicalReserved'), t('inventory.col.physicalAvail'),
    t('inventory.col.onOrder'), t('inventory.col.orderedReserved'), t('inventory.col.totalOrdered'),
    t('inventory.col.totalAvailable'),
  ]
  const body = rows.map(r => [
    ...(isEmpresaAll ? [r.dataareaid] : []),
    fmtArt(r.articulo), r.descripcion, r.familia ?? '',
    ...(isEmpresaAll ? [r.almacen ?? ''] : []),
    r.color ?? '',
    ...(showTalla ? [r.talla ?? ''] : []),
    r.estilo ?? '',
    r.cantidadInventarioFisico, r.cantidadFisicaReservada, r.cantidadFisicaDisponible,
    r.cantidadEnPedido, r.cantidadOrdenadaReservada, r.cantidadPedidoEnTotal,
    r.cantidadTotalDisponible,
  ])
  return [header, ...body]
}

export function exportInventarioExcel(rows: InventarioRow[], opts: InventarioExcelOpts): void {
  const wsData = buildInventarioExcelAoa(rows, opts)
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet(wsData)
  XLSX.utils.book_append_sheet(wb, ws, opts.t('inventory.excel.sheetName'))
  XLSX.writeFile(wb, `${opts.t('inventory.excel.filename')}_${new Date().toISOString().slice(0, 10)}.xlsx`)
}
